import React from "react";
import "./Mindset.scss";

const Mindset = () => {
  return (
    <div className="Second_container">
      <div className="imagelol">
        <img
          src="https://i.ibb.co/pwksk39/image-removebg-preview-1.png"
          alt=""
        />
      </div>
      <div className="rightSecond">
        <h2>95% of what goes on in our heads comes from our subconscious.</h2>
        <p style={{ marginTop: "30px" }}>
          By talking it out, we get to see our subconscious thoughts and
          emotions, and understand how they impact the way we show-up, so we
          have choice on how to deal with them, putting us back in control of
          how we’re living and working.​
        </p>
      </div>
    </div>
  );
};

export default Mindset;
